import { render, staticRenderFns } from "./WalletUpdateLoan.vue?vue&type=template&id=ceac46dc&scoped=true&"
import script from "./WalletUpdateLoan.vue?vue&type=script&lang=js&"
export * from "./WalletUpdateLoan.vue?vue&type=script&lang=js&"
import style0 from "./WalletUpdateLoan.vue?vue&type=style&index=0&id=ceac46dc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceac46dc",
  null
  
)

export default component.exports